import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import Button from '../ui/Button/Button'
import Image from '../ui/Image/Image'

import styles from './Campaign.module.scss'
import arrowUpRight from '../../assets/images/arrowUpRight.svg'

const CampaignLinks = ({ links, title }) => {
  let navigate = useNavigate()

  const handleNavigation = (url, isExternal) => {
    if (isExternal) window.open(url, '_blank', 'noopener,noreferrer')
    else navigate(url)
  }

  return (
    <>
      {links && links?.length > 0 ? (
        <div className="page-container">
          {title && <h2 className={styles.linksTitle}>{title}</h2>}
          <div className={classNames(styles['linksContainer'])}>
            {links?.map((button) => {
              return (
                <Button
                  key={button?.id}
                  aria-label={button?.label}
                  classname={styles.links}
                  buttonDetails={button}
                  text={button?.label}
                  handleClick={() =>
                    handleNavigation(button?.path, button?.isExternal)
                  }
                >
                  <Image
                    src={arrowUpRight}
                    alt={button?.label}
                    className={styles.btnImg}
                  />
                </Button>
              )
            })}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default CampaignLinks
